'use client';

import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';

import Carousel, { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import { Heading } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/product/components/recommended-products/type';
import { CubicProductCard } from '@/components/shared/components/cards';
import IconicProductCard from '@/components/shared/components/cards/iconic-product';
import RoundedIcon from '@/components/shared/components/icon/rounded';

import { DATA_CY_PRODUCT_CARD_ICONIC } from '@/constant/cypress';
import imagesList from '@/constant/images-list';

export default function RecommendedProducts({ products, logo, title = '', className,  ...props }: Props) {
  return (
    <>
      <Container center className='justify-start'>
        <RoundedIcon
          className='z-10'
          icon={
            <XImage
              src={imagesList.icons.relatedProductIcon}
              alt={logo?.title}
              width={22}
              height={22}
              className='rounded-full'
            />
          }
        />

        <XImage
          src={logo?.publicLink?logo?.publicLink:imagesList.images.productDefaultCover}
          alt={logo?.title}
          width={44}
          height={44}
          className='-mr-4 rounded-full border-2 border-[#FFFFFF]'
        />
        <Heading type={HEADING_TYPE.H2} className='pr-4 text-lg font-bold text-[#424244]'>
          {title}
        </Heading>
      </Container>

      <Container className='flex flex-col gap-3 pt-6 md:hidden md:flex-row'>
        {products?.map((product) => {
          return <IconicProductCard key={product.id} data={product} />;
        })}
      </Container>

      <Container className='hidden w-full pt-6 md:block [&_.swiper-wrapper]:p-4'>
        <Carousel
          className='[&_.swiper-button-disabled]:hidden'
          spaceBetween={20}
          slidesPerView='auto'
          navigation={{
            nextEl: '.custom-swiper-button-next',
            prevEl: '.custom-swiper-button-prev',
          }}
        >
          {products.map((item) => (
            <CarouselItem key={item.id} className='w-[195px]!'>
              <CubicProductCard key={item.id} {...item} data-cy={DATA_CY_PRODUCT_CARD_ICONIC} />
            </CarouselItem>
          ))}
          <Container
            className='custom-swiper-button-next absolute left-0 top-1/2 z-10 h-full -translate-y-1/2 transform cursor-pointer border-r-[1px] border-r-[#F8F8F8] bg-[#FFFFFF] px-2'
            center
          >
            <Container className='rounded-full bg-[#9099A612] p-2 text-[#7E899B] transition duration-300 hover:bg-[#878F9B] hover:text-[#FFFFFF]'>
              <SlArrowLeft />
            </Container>
          </Container>
          <Container
            className='custom-swiper-button-prev absolute right-0 top-1/2 z-10 h-full -translate-y-1/2 transform cursor-pointer border-l-[1px] border-l-[#F8F8F8] bg-[#FFFFFF] px-2'
            center
          >
            <Container className='rounded-full bg-[#9099A612] p-2 text-[#7E899B] transition duration-300 hover:bg-[#878F9B] hover:text-[#FFFFFF]'>
              <SlArrowRight />
            </Container>
          </Container>
        </Carousel>
      </Container>
    </>
  );
}
